var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"refwarningmain",staticClass:"company-main"},[_c('div',{staticClass:"company-warning-title"},[_vm._v("低电量预警列表")]),_c('Table',{attrs:{"height":_vm.tableHeight,"columns":_vm.columns1,"data":_vm.list}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }